import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useDispatch, useSelector} from 'react-redux';
import {useInflight} from 'src/hooks/redux';
import {getReferralNotification} from 'src/utils/referrer-portal';
import {
  getNotification,
  updateNotification,
  getAutoSubmitNotification,
  updateAutoSubmitNotification,
} from 'src/action-creators/referrer-portal/authentication';
import {selectNotification} from 'src/selectors/referrer-portal';
import {
  SubTitleMedium,
  BodySmall,
  CardHeader,
  Card,
  CardContent,
  Toggle,
} from '@spaced-out/ui-design-system/lib/components/index';
import css from 'src/components/referrer-portal/settings/settings.css';


const Notification = () => {
  const dispatch = useDispatch();
  const {t} = useLabelTranslation();
  const REFERRAL_NOTIFICATION = getReferralNotification(t);

  const notificationData:
    | {
        [key: string]: boolean;
      }
    | null
    | undefined = useSelector(selectNotification);

  const isNotificationLoading = useInflight(getNotification());

  const onToggleNotification = (field: string, value: boolean) => {
    const payload = {settings: {...notificationData, [field]: value}} as const;
    dispatch(updateNotification(payload));
  };

  React.useEffect(() => {
    dispatch(getNotification());
  }, []);

  return (
    <div className={css.notificationCard}>
      {/* @ts-expect-error - TS2769 - No overload matches this call. */}
      <Card type="primary">
        <CardHeader className={css.toggleLabel}>
          {t('Referral_Notifications', 'Referral Notifications')}
        </CardHeader>
        <CardContent className={css.row}>
          {REFERRAL_NOTIFICATION.map((notification) => (
            <React.Fragment key={notification.key}>
              <div className={css.defaultGap}>
                <SubTitleMedium>{notification.title}</SubTitleMedium>
                <BodySmall color="secondary">
                  {notification.description}
                </BodySmall>
              </div>

              <Toggle
                onChange={(e) =>
                  onToggleNotification(notification.key, e.checked)
                }
                checked={
                  notificationData ? notificationData[notification.key] : false
                }
                disabled={isNotificationLoading}
              />
            </React.Fragment>
          ))}
        </CardContent>
      </Card>
      <AutoSubmitRequestConfig />
    </div>
  );
};

export default Notification;

export const AutoSubmitRequestConfig = ({className}: {className?: string}) => {
  const {t} = useLabelTranslation();
  const dispatch = useDispatch();
  const [autoSubmit, setAutoSubmit] = React.useState(false);

  const isAutoSubmitNotificationLoading = useInflight(
    getAutoSubmitNotification(),
  );

  const onToggleAutoSubmit = () => {
    const payload = {auto_submit_lead: !autoSubmit} as const;
    dispatch(updateAutoSubmitNotification(payload)).then((response) =>
      //@ts-expect-error
      setAutoSubmit(response?.auto_submit_lead),
    );
  };

  React.useEffect(() => {
    dispatch(getAutoSubmitNotification()).then((response) =>
      setAutoSubmit(response?.auto_submit_lead),
    );
  }, []);

  return (
    // @ts-expect-error - TS2769 - No overload matches this call.
    <Card type="primary" classNames={{wrapper: className}}>
      <CardHeader>
        {t('Referral_Request_Preference', 'Referral Request Preference')}
      </CardHeader>
      <CardContent className={css.row}>
        <React.Fragment>
          <div className={css.defaultGap}>
            <SubTitleMedium>
              {t('Auto_Submit_Requests', 'Auto Submit Requests')}
            </SubTitleMedium>
            <BodySmall color="secondary">{`${t(
              'A_referral_request_received_through_social_sharing_is_automatically_submitted',
              'A referral request received through social sharing is automatically submitted',
            )}.`}</BodySmall>
          </div>

          <Toggle
            onChange={onToggleAutoSubmit}
            disabled={isAutoSubmitNotificationLoading}
            checked={autoSubmit}
          />
        </React.Fragment>
      </CardContent>
    </Card>
  );
};
